import { FormControlLabel, Switch as SwitchMui, withStyles } from '@material-ui/core'
import React from 'react'

const PrimarySwitch = withStyles({
  switchBase: {
    // color: "#0d6efd",
    '&$checked': { color: "#198754" },
    '&$checked + $track': { backgroundColor: "#38b77c" },
  },
  checked: {},
  track: {},
})(SwitchMui);

const defaultProps = {
  onChange: () => {},
  color: 'primary',
  checked: true,
  size: 'small',
  label: '',
}

const createSwitchName = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  return `switch-${Math.random().toString(36).slice(2)}`
}

const Switch = (props) => {
  const newProps = { ...defaultProps, ...props }
  const { onChange, label, checked, color, size } = newProps
  const name = newProps.name || createSwitchName()
  let fontSize

  const handleChange = (event) => onChange(event.target.checked)

  if (size === "small") fontSize = "fs-14"
  
  return (
    <FormControlLabel
      label={<span className={['user-select-none', fontSize].filter(Boolean).join(" ")}>{label}</span>}
      control={<PrimarySwitch name={name} onChange={handleChange} checked={checked} size={size} />}
      color={color}
    />
  )
}

export default Switch